import { Directive, HostListener, Input, ElementRef } from '@angular/core';

@Directive({
  selector: 'img[appImgFallback]'
})
export class ImgFallbackDirective {
  @Input()
  set appImgFallback(value: string | null | undefined) {
    this.fallback = value || '/assets/preview/no_preview.png';
  }

  private fallback = '';

  @Input() removeClassesOnError = false;
  @Input() parentClassOnError?: string;

  private fallbackApplied = false;

  constructor(private el: ElementRef<HTMLImageElement>) {}

  @HostListener('error')
  onError(): void {
    if (this.fallbackApplied) {
      return;
    }

    this.fallbackApplied = true;

    const img = this.el.nativeElement;

    if (this.removeClassesOnError) {
      img.className = '';
    }

    if (this.parentClassOnError && img.parentElement) {
      img.parentElement.className = this.parentClassOnError;
    }

    img.src = this.fallback;
  }
}
